import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import { Card, Modal } from "react-bootstrap";
import axios from "axios";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useStripePayment } from "../../../CustomHooks/useStripePayment";
import CheckoutFormStripe from './CheckoutFormStripe';
import Navigation from './../../Layouts/Header/Navigation';

function StripePayment(props) {

    const {
        stripeMakePayment,
        stripeBuffer,
        clientSecret,
        publicKey,
        error,
        stripeModalShow,
        setStripeModalShow,
      } = useStripePayment({
        amount: localStorage.getItem("amount"),
        event_type: localStorage.getItem("event_type"),
        event_id:localStorage.getItem("event_id") ,
      });



    const stripePromise = loadStripe(
        // publicKey
        'pk_live_51M7EDzIUEL35EfmyowFaTv6FVlbjTV5MzbbuQ6Aj6D0KkqEOBBLjrHeBGzWrrXpQzQWASy6rHJLZTrg86mnrG2zK00KzyyEnG4'
    );

    useEffect(() => {
        stripeMakePayment();
    }, [])

    const appearance = {
        theme: "stripe",
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <>
        <Navigation />

        <div className="container my-5">
        <div className="d-flex " style={{justifyContent:"center"}}>
        <Elements options={options} stripe={stripePromise}>
            <CheckoutFormStripe />
        </Elements>

        </div>
        </div>

        </>
    );
}

export default StripePayment;
